import React from "react";
import { createPortal } from "react-dom";
import styles from "./feeCalculatorPopup.module.scss";

const FeeCalculatorPopup = ({ isOpen, onClose, feeCalculatorUrl }) => {
  if (!isOpen || typeof document === "undefined") return null;

  return createPortal(
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
            <path d="M1 35.5L35.5 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M35.5 35.5L1 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <div className={styles.feeCalculatorContainer}>
          <iframe
            src={feeCalculatorUrl}
            title="Fee Calculator"
            className={styles.feeCalculatorFrame}
            allowFullScreen
            allow="clipboard-write; clipboard-read; web-share"
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FeeCalculatorPopup;
